module.exports = __webpack_public_path__ + "static/media/close_gray.ae38ef74.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close_gray.svg
// module id = 103
// module chunks = 3